import { render, staticRenderFns } from "./3d_model.vue?vue&type=template&id=73334db7&scoped=true&lang=pug&"
import script from "./3d_model.vue?vue&type=script&lang=js&"
export * from "./3d_model.vue?vue&type=script&lang=js&"
import style0 from "./3d_model.vue?vue&type=style&index=0&id=73334db7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73334db7",
  null
  
)

export default component.exports